import { Component, OnInit } from '@angular/core';
import { SettingsService } from 'src/app/@core/utils';

@Component({
  selector: 'smart-page-footer',
  templateUrl: './page-footer.component.html',
  styles: []
})
export class PageFooterComponent implements OnInit {

  copyright;

  constructor(public settings: SettingsService) {
    this.copyright = this.settings.getAppSetting('copyright');
  }

  ngOnInit() {
  }

}
